import { Controller } from "@hotwired/stimulus"

// This controller is used to add the selected or currently filtered leads lists to the user's favorites.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedCompanyListIds: { type: Array, default: [] },
    }
  }

  // This function is triggered using stimulus actions to submit a temporary form to verify the selected or filtered
  // leads.
  submit() {
    fetch("/company-lists/favorite", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({ company_list_ids: this.selectedCompanyListIdsValue, filters: this.filtersValue })
    }).then(response => {
      if (response.status === 201) {
        App.displayFlash("success", i18n.t("js.back.company_list.favorites.added"))
        return
      }

      App.displayFlash("danger", i18n.t("js.back.company_list.favorite.error"))
    })
  }

  // This function is triggered using stimulus actions to update the selected leads value.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedCompanyListIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedCompanyListIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedCompanyListIdsValue = []
    }
  }
}
